<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="end">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">账号管理</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <a-button type="primary">
                            添加
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '10px 24px 24px 24px'}">
                <a-table
                    :columns="columns"
                    :row-key="record => record.uuid"
                    :data-source="data"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    bordered
                >
                    <a slot="action" slot-scope="record" href="javascript:;" :uuid="record.uuid">删除</a>
                </a-table>
            </a-col>
        </a-row>

    </div>
</template>

<script>
const columns = [
    {
        title: '用户名',
        dataIndex: 'username',
        sorter: false,
    },
    {
        title: '创建时间',
        dataIndex: 'createTime',
        sorter: true,
    },
    {
        title: '操作',
        dataIndex: '',
        key: 'x',
        scopedSlots: {
            customRender: 'action'
        }
    },

];
export default {
    name: "Member",
    data() {
        return {
            data: [],
            pagination: {},
            loading: false,
            columns,
        };
    },
    methods: {
        handleTableChange(pagination, filters, sorter) {
            const pager = {...this.pagination};
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                size: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
            });
        },
        fetch: function (params = {}) {
            this.loading = true
            let that = this
            this.$ajax.get(this.$host+"/admin/member/list", {
                params: {
                    size: 10,
                    ...params,
                }
            }).then(function (res) {
                that.loading = false
                const result = res.data;
                if (result.code === 200 && result.data.list.length > 0) {
                    const pagination = {...that.pagination};
                    pagination.total = result.data.total;
                    that.data = result.data.list;
                    that.pagination = pagination;
                }
            }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.fetch();
    }
}
</script>

<style scoped>

</style>